import { DepositProvider } from './DepositPageContext';
import DepositScreenContainer from '../../containers/DepositScreenContainer';

export default function DepositPage(action = '') {
  return (
    <DepositProvider>
      <DepositScreenContainer actionType={action} />
    </DepositProvider>
  );
}
